import { Suspense } from 'react';

import { lazyRoute } from 'src/routes/lazy-route';
import { Outlet } from 'react-router-dom';
// auth
import { GuestGuard } from 'src/auth/guard';
// layouts
import AuthClassicLayout from 'src/layouts/auth/classic';
// components
import { SplashScreen } from 'src/components/loading-screen';

import { paths } from '../paths';

// ----------------------------------------------------------------------

// JWT
// const JwtLoginPage = lazyRoute(() => import('src/pages/auth/jwt/login'));

// FIREBASE
const FirebaseLoginPage = lazyRoute(() => import('src/pages/auth/firebase/login'));

// ----------------------------------------------------------------------

export const authRoutes = [
  {
    path: paths.root,
    element: (
      <GuestGuard>
        <Suspense fallback={<SplashScreen />}>
          <Outlet />
        </Suspense>
      </GuestGuard>
    ),
    children: [
      {
        path: paths.login,
        element: (
          <AuthClassicLayout>
            <FirebaseLoginPage />
          </AuthClassicLayout>
        ),
      },
    ],
  },
];
